import React, { useState, useEffect, useRef } from 'react';
import { Form, Field } from 'react-final-form'
import { Link, useNavigate, useParams} from 'react-router-dom';
import { useIndexedDB } from 'react-indexed-db';
import { useApi } from '../components/Api';
import { useCustomFields } from './CustomFields';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCreative } from 'swiper';
import BottomNavigation from '../components/BottomNavigation'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import { v4 as uuidv4 } from 'uuid';
import { strings } from '../localization';
import { confirmAlert } from 'react-confirm-alert'; // Import
import DataTable from 'react-data-table-component';
import {useOrder} from './OrderForm';
import { formatCurrency } from '../components/Cart';
import bs5Styles from '../assets/themes/bs5';

//const regionNamesInLocaleLanguage = new Intl.DisplayNames('fr', { type: 'region' });
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

const validate = values => {

    const errors = {}
   
    if (!values.company) {
      errors.company = 'La raison sociale est obligatoire'
    }
    if (!values.billing_address_1) {
      errors.billing_address_1 = 'L\'adresse est obligatoire'
    }
    if (!values.billing_postal_code) {
      errors.billing_postal_code = 'Le code postal est obligatoire'
    }
    if (!values.billing_city) {
      errors.billing_city = 'La ville est obligatoire'
    }

    if (!values.billing_country) {
        errors.billing_country = 'La ville est obligatoire'
      }
   
   
    if (!values.billing_phone && !values.billing_mobile) {
      errors.billing_phone = 'Le téléphone est obligatoire'
      errors.billing_mobile = 'Le téléphone est obligatoire'
    }
    if (!values.billing_email || ! emailRegExp.test(values.billing_email)) {
      errors.billing_email = 'L\'email est obligatoire'
    }

    

    return errors

}

const validateAddress = values => {

    const errors = {}

    if (!values.address1) {
        errors.address1 = 'L\'adresse est obligatoire'
    }
    if (!values.postal_code) {
        errors.postal_code = 'Le code postal est obligatoire'
    }
    if (!values.city) {
        errors.city = 'La ville est obligatoire'
    }

    if (!values.country) {
        errors.country = 'Le pays est obligatoire'
    }


    return errors
}


const validateContact = values => {

    const errors = {}

    if (!values.first_name) {
        errors.first_name = 'Le prénom est obligatoire'
    }
    if (!values.last_name) {
        errors.last_name = 'Le nom est obligatoire'
    }
    if (!values.phone && !values.mobile) {
        errors.phone = 'Un téléphone est obligatoire'
    }

    if (!values.mobile && !values.phone) {
        errors.mobile = 'Un téléphone est obligatoire'
    }

    if(values.email && !emailRegExp.test(values.email))
    errors.email = "L'email n'est pas valide"

    return errors
}


const CustomerForm = (props) => {

    let { customerRef } = useParams()
    const swiperRef = useRef();
    const [user, { setUser, updateExcludedCategories }]  = useApi();
 
    const [ activeIndex, setActiveIndex ] = useState(0);

    const [ showFormAddress, setShowFormAddress ] = useState(false);
    const [ showFormContact, setShowFormContact ] = useState(false);

    const handleCloseFormAddress = () => setShowFormAddress(false);
    const handleCloseFormContact = () => setShowFormContact(false);

    const [ editAddress,setEditAddress] = useState(null);
    const [ editContact,setEditContact] = useState(null);

    const [ customer, setCustomer ] = useState(props.customer);
 

    const [ formChanges, setFormChanges ] = useState(false)
    const [ saved, setSaved ] = useState(false)
    const [ categoryChanges, setCategoryChanges ] = useState(false)

     //let customers = JSON.parse( localStorage.getItem('customers') ) 
     const { getAll, update } = useIndexedDB('catalog');
     const [ customers, setCustomers] = useState([])
     const [orders, setOrders] = useState([]);

    const [categories, setCategories] = useState([]);
    const [excludedCategories, setExcludedCategories] = useState([]);
    const [currentClient, setCurrentClient] = useState(null);
    const [customerOrders, setCustomerOrders] = useState([]);
    
    
     useEffect(() => {
         getAll().then(dataFromDB => {
             let foundCustomers = dataFromDB.find(i => i.type == 'customers')?.data ?? [];             
             let foundCustomer = foundCustomers.find((c) => c.ref == customerRef) 
             let foundOrders = dataFromDB.find(i => i.type == 'orders')?.data ?? [];

             setCustomer(foundCustomer) 
             setCustomers(foundCustomers)
             setCategories(dataFromDB.find(i => i.type == 'categories')?.data ?? [])
             setOrders(dataFromDB.find(i => i.type === 'orders')?.data ?? [])


            if(foundCustomer) {
                setCustomer(foundCustomer)
                if (foundCustomer.excluded_categories) {
                    setExcludedCategories(foundCustomer.excluded_categories)
                }

                const filteredOrders = foundOrders.filter( (order) => {
                    return foundCustomer.ref === order.customer
                })
                setCustomerOrders(filteredOrders);
            }
            else {
                setCustomer({ref:'',addresses: [], contacts: [], prospect: true, user: user, billing_duplicate: false})   
                setExcludedCategories([]);
            }
         });

        if (sessionStorage.getItem('orders.current_client')) {
            setCurrentClient(JSON.parse(sessionStorage.getItem('orders.current_client')));
        }
 
     }, []);
 

    const handleSubmitCustomer = (values) => {

        
        let updated_customer = { ...customer, ...values } 
        
        if(! updated_customer.ref ){
            updated_customer.ref = "NC"+user.ref+Date.now();
            updated_customer.prospect = true;
            
        }
        if(updated_customer.billing_duplicate)
        {
            updated_customer.addresses.push({
                ref: "NA"+user.ref+Date.now(),
                address1: updated_customer.billing_address_1,
                address2: updated_customer.billing_address_2,
                address3: '',
                postal_code: updated_customer.billing_postal_code,
                city: updated_customer.billing_city,
                country: updated_customer.billing_country,
                phone: updated_customer.billing_phone,
                mobile: updated_customer.billing_mobile,
                email: updated_customer.billing_email
            })

            updated_customer.billing_duplicate = false;
        }

        setCustomer(updated_customer)
        setFormChanges(false)
        

        let newCustomers = customers.map(c => 
            c.ref == updated_customer.ref ? updated_customer : c
        )     
        
        if(! newCustomers.find(c => c.ref === updated_customer.ref))
        newCustomers.push(updated_customer);

        update({type: 'customers', data: newCustomers}).then(event => {

            setSaved(true)
            setUser({...user,customer_num: user.customer_num+1})

        })

        //props.handleSubmit(updated_customer);

    }

    const handleSubmitAddress = values => {

        let addresses = customer.addresses

        if(values.ref)
        addresses = addresses.map((a) => {
            
            if(a.ref == values.ref)
            return { ...a, ...values }
            else
            return a
            
        }) 
        else
        {
            values.ref = "NA"+user.ref+Date.now();
            addresses = [ ...addresses, values ]

        }


        let newCustomer = {...customer, addresses: addresses}

        setUser({...user,address_num: user.address_num+1})

        setCustomer(newCustomer)

        setFormChanges(true)

        setShowFormAddress(false)

        

    }

    const handleSubmitContact = values => {

        let contacts = customer.contacts

        if(values.ref)
        contacts = contacts.map((c) => {
            
            if(c.ref == values.ref)
            return { ...c, ...values }
            else
            return c
            
        }) 
        else
        {
            values.ref = "NC"+user.ref+Date.now();
            contacts = [ ...contacts, values ]

        }

        let newCustomer = {...customer, contacts: contacts}

        setUser({...user,contact_num: user.contact_num+1})

        setCustomer(newCustomer)
        setFormChanges(true)

        setShowFormContact(false)

    }

    

    const handleEditAddress = (address) => {

        setEditAddress(address)
        setShowFormAddress(true)

    }


    const handleDeleteAddress = (address) => {

        confirmAlert({
            title: 'Supprimer une addresse',
            message: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
            buttons: [
              {
                label: 'Oui',
                onClick: () => {
                    setEditAddress(null)
                    setCustomer({...customer,addresses:customer.addresses.filter(a => a != address)})
                    setFormChanges(true)
                }
              },
              {
                label: 'Annuler',
                onClick: () => {
                    
                }
              }
            ]
        });

       

    }

    const handleEditContact = (contact) => {

        setEditContact(contact)
        setShowFormContact(true)

    }

    const handleDeleteContact = (contact) => {

        confirmAlert({
            title: 'Supprimer une addresse',
            message: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
            buttons: [
              {
                label: 'Oui',
                onClick: () => {
                    setEditContact(null)
                    setCustomer({...customer,contacts:customer.contacts.filter(c => c != contact)})
                    setFormChanges(true)
                }
              },
              {
                label: 'Annuler',
                onClick: () => {
                    
                }
              }
            ]
        });

        
    }

    const [ { RenderInput, RenderCheckbox, RenderDate, RenderTextArea, RenderClientField, RenderSelect, RenderCountryField} ] = useCustomFields()

    

    const fieldClass = {label:'col-1', input:'col-2'}
    let submit

   
    const formatContact = (value,name) => ! value || customer?.prospect ? {label:user?.display_name, value:user?.ref} : {label: value?.display_name, value: value?.ref}
    const parseContact = (value, name) => value ? { ref: value.value } : ''

    const categoriesOptions =  [];
    const recursiveGetCategory = (cats, level = -1) => {
        level++
        cats.forEach(c => {
            categoriesOptions.push({ label: c.title, value: c.ref, parent: c.parent, level: level});

            if (c.children.length)
                recursiveGetCategory(c.children, level)
        })
    }
    recursiveGetCategory(categories);

    const recursiveFindCategory = (cats, ref) => {
        for (let i = 0; i < cats.length; i++) {
            if (cats[i].ref == ref)
                return cats[i]

            const found = cats[i].children ? recursiveFindCategory(cats[i].children,ref) : false;
            if (found)
                return found;
        };
        return false;
    }

    const recursiveGetChildCategory = (fc, childrenRefs) => {
        for (let i = 0; i < fc.children.length; i++) {
            childrenRefs.push({
                ref: fc.children[i].ref
            })
            if (fc.children[i].children) {
                childrenRefs = recursiveGetChildCategory(fc.children[i], childrenRefs);
            }
        }
        return childrenRefs;
    }

    const recursiveGetParentCategory = (fc, parentRefs) => {
        if (fc.parent) {
            parentRefs.push({
                ref: fc.parent.ref
            })
            if (fc.parent.parent) {
                parentRefs = recursiveGetParentCategory(fc.parent, parentRefs);
            }
        }
        return parentRefs;
    }

    const handleCategoryPermission = (checked, categoryRef) => {
        const foundCategory = recursiveFindCategory(categories, categoryRef);
        const childrenRefs = recursiveGetChildCategory(foundCategory, []);
        const parentRefs = recursiveGetParentCategory(foundCategory, []);

        if (checked) {
            const refsToRemove = excludedCategories.filter((c) => {
                if (
                    String(c.ref) !== String(categoryRef) 
                    && childrenRefs.findIndex((ch) => String(c.ref) === String(ch.ref)) === -1
                    && parentRefs.findIndex((ch) => String(c.ref) === String(ch.ref)) === -1
                ) {
                    return c;
                }
                return false;
            });
            setExcludedCategories(refsToRemove);
        } else {
            let refsToAdd = [];
            let cIdx = excludedCategories.findIndex((c) => String(c.ref) === String(categoryRef));
            // add selected category
            if (cIdx === -1) {
                refsToAdd.push({ ref: categoryRef });
            }
            // add children category if any
            for (let i = 0; i < childrenRefs.length; i++) {
                const child = childrenRefs[i];
                let chIdx = excludedCategories.findIndex((c) => String(c.ref) === String(child.ref));
                if (chIdx === -1) {
                    refsToAdd.push({ ref: child.ref });
                }
            }
            setExcludedCategories(excludedCategories.concat(refsToAdd));
        }
        setCategoryChanges(true);
    }
    const saveCategoryPermission = () => {
        // store favorites data
        customer.excluded_categories = excludedCategories;
        updateExcludedCategories(customer);
        setCategoryChanges(false);
        if (currentClient && currentClient.ref === customer.ref) {
            currentClient.excluded_categories = excludedCategories;
            sessionStorage.setItem('orders.current_client', JSON.stringify(currentClient));
            setCurrentClient(JSON.parse(sessionStorage.getItem('orders.current_client')));
        }
    }

    const locale = 'fr-FR';
    const { orderTypes } = useOrder()

    const columns = [
        {
            name: strings.ref,
            selector: row => row.ref,
            sortable: true,
        },
        {
            name: strings.order_table_date,
            selector: row => row.date,
            sortable: true,
            center: true,
            format: (row,index) => Intl.DateTimeFormat(locale).format(new Date(row.date * 1000)),
        },
        {
            name: strings.order_table_date_livraison,
            selector: row => row.shipping_date,
            sortable: true,
            center: true,
            format: (row,index) => row.shipping_week > 0 ? ('Semaine ' + row.shipping_week) : Intl.DateTimeFormat(locale).format(new Date(row.shipping_date * 1000)),
        },
        {
            name: strings.order_table_type,
            selector: row => orderTypes.find( t => t.value == row.type)?.label,
            center: true,
            sortable: true,
        },
        {
            name: strings.order_table_lignes,
            selector: row => row.items.length,
            right: true,
            sortable: true,
        },
        {
            name: 'MONTANT',
            selector: row => formatCurrency(row.total),
            right: true,
            sortable: true,
        },
        {
            name:'ACTIONS',
            selector: row => row.ref,
            right: true,
            width:'100px',
            format: row => row.status >1  ? '' : <button type='button' onClick={ () => handleRemoveOrder(row.ref) } className="btn"><i className='fa fa-trash'></i></button>
        }
    ];

    const handleRemoveOrder = (ref) => {
        confirmAlert({
            title: 'Supprimer une commande',
            message: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
            buttons: [
                {
                    label: 'Oui',
                    onClick: () => {
                        let newOrders = orders.filter(o => o.ref != ref)
                        update({type: 'orders', data: newOrders}).then(event => {
                            setOrders(newOrders)
                            const filteredOrders = newOrders.filter( (order) => {
                                return customer.ref === order.customer
                            })
                            setCustomerOrders(filteredOrders);
                        })
                    }
                },
                {
                    label: 'Annuler',
                    onClick: () => {}
                }
            ]
        });
    }

    const paginationComponentOptions = {
        rowsPerPageText: strings.orders_page,
        rangeSeparatorText: strings.orders_of,
        selectAllRowsItem: true,
        selectAllRowsItemText: strings.orders_all,
    };

    let navigate = useNavigate();
    const editOrder = (ref) => {
        navigate('/order/'+ref)
    }
    const canShowCategoryPermission = true;
    const clientDetailsReadonly = !!customerRef;

    return (
        <>
            <Form
            initialValues={customer}
            onSubmit={handleSubmitCustomer}
            validate={validate}
            render={({ handleSubmit, form, values, submitting, pristine, dirty, submitSucceeded, modifiedSinceLastSubmit }) => {
                submit = handleSubmit
                
                return (
                <>
                <form onSubmit={handleSubmit} className="customers-form">
                    <div className='container-xxl'>
                        <div className='row d-block'>
                            <Swiper ref={ swiperRef } spaceBetween={100} onActiveIndexChange={ (swiper) => setActiveIndex(swiper.activeIndex)} effect="creative"
                                        creativeEffect={{
                                            prev: {
                                                shadow: true,
                                                translate: [0, 0, -100],
                                                opacity: 0
                                            },
                                            next: {
                                                translate: [0, "100%", 0],
                                                opacity: 0
                                            },
                                        }}
                                        modules={ [ EffectCreative ] } 
                                        allowTouchMove={ false }
                                        simulateTouch={ false }  >
                            <SwiperSlide className='border-1 border-white border p-5 bg-primary'>   
                                <div className="row">
                                    <div className='col-lg-6'>
                                        <div className='row align-items-center'>
                                            <Field name="ref" readonly label={ <div className='d-flex justify-content-between align-items-center'>{ strings.client_edition}<i className={ 'fa fa-circle  ms-3 text-' + (customer?.monitoring === null ? 'warning' : ( customer?.monitoring ? 'success' : 'danger' )) }></i></div> } placeholder="Code" classes={ {label:'col-3',input:'col-3'}} component={ RenderInput } />
                                            <Field name="company" readonly={clientDetailsReadonly} label={false} maxLength={35} placeholder={ strings.client_raison } classes={ {label:'col-3',input:'col-6'}} component={ RenderInput } />
                                            <Field name="billing_address_1" readonly={clientDetailsReadonly} maxLength={35} label={ strings.customer_address} classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="billing_address_2" readonly={clientDetailsReadonly} maxLength={35} label={ strings.complement } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="billing_postal_code" readonly={clientDetailsReadonly} maxLength={35} label={ strings.customer_postal_code} classes={ {label:'col-3', input:'col-3'} } component={ RenderInput } />
                                            <Field name="billing_city" readonly={clientDetailsReadonly} maxLength={35} label={ strings.customer_city } classes={ {label:'col-1 text-end', input:'col-5'} } component={ RenderInput } />
                                            <Field name="billing_country" readonly={clientDetailsReadonly} maxLength={35} label={ strings.customer_country } classes={ {label:'col-3', input:'col-9'} } component={ RenderCountryField }  />
                                            <Field name="billing_phone" readonly={clientDetailsReadonly} maxLength={21} label={ strings.customer_phone} placeholder="Fixe" classes={ {label:'col-3', input:'col-4'} } component={ RenderInput } />
                                            <Field name="billing_mobile" readonly={clientDetailsReadonly} maxLength={21} label={ false } placeholder={ strings.customer_mobile} classes={ {label:'col-1', input:'col-5'} } component={ RenderInput } />                                            
                                            <Field name="billing_email" readonly={clientDetailsReadonly} maxLength={69} label={ strings.email } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="billing_duplicate" readonly={clientDetailsReadonly} placeholder={ strings.billing_duplicate } classes={ {label:'col-3', input:'col-9'} } type="checkbox" component={ RenderCheckbox } />
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='row justify-content-end align-items-center'>
                                            <Field name="contact" readonly={clientDetailsReadonly} label={ strings.representant } classes={ {label:'col-3',input:'col-9'}} parse={ parseContact } format={ formatContact } component={ RenderSelect } isDisabled={clientDetailsReadonly}    options={[ customer?.prospect ? {label:user?.display_name, value:user?.ref} : {label: customer?.user?.display_name, value: customer?.user?.ref}]} />      
                                            <Field name="company_type" readonly={clientDetailsReadonly} maxLength={35} label={ strings.forme_jur } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="company_siret" readonly={clientDetailsReadonly} maxLength={14} label={ strings.siret } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="company_ape" readonly={clientDetailsReadonly} maxLength={7} label={ strings.ape } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="vat_number" readonly={clientDetailsReadonly} maxLength={35} label={ strings.intracom } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="payment_method" readonly={clientDetailsReadonly} maxLength={35} label={ strings.reglement } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } />
                                            <Field name="payment_delay" readonly={clientDetailsReadonly} maxLength={35} label={ strings.delai } classes={ {label:'col-3', input:'col-9'} } component={ RenderInput } /> 
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className='border-1 border-white border p-5 bg-primary'>
                                <div className='row customer-items mb-3'>
                                { customer?.addresses.map( (address,index) => {

                                    return (
                                        <div className='col-lg-4' key={ index }>
                                            <div className='bg-secondary p-3 text-start customer-item h-100'>
                                                <strong>{ address.address1 }</strong><br />
                                                { address.address2 && 
                                                <div>{ address.address2 }</div> }
                                                { address.address3 && 
                                                <div>{ address.address3 }</div> }
                                                { [ address.postal_code,address.city, address.country?.label].filter(a => a).join(' ')  }
                                                { address.phone && 
                                                <div><strong><i className='fa fa-phone-alt me-2'></i></strong>{ address.phone }</div> }
                                                { address.email && 
                                                <div><strong><i className='fa fa-envelope me-2'></i></strong>{ address.email }</div> }
                                                <div className='btn-group'>
                                                    { customer.prospect && <button  type="button" className='btn btn-primary me-1' onClick={ () => handleDeleteAddress(address) }><i className='fa fa-trash'></i></button> }
                                                    <button  type="button" className='btn btn-primary' onClick={ () => handleEditAddress(address) }><i className='fa fa-edit'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                </div>
                                <button type='button' onClick={ () => handleEditAddress(null) } className='btn btn-secondary btn-lg'>
                                    <i className='fa fa-plus me-3'></i>{ strings.address_add }
                                </button>
                            </SwiperSlide>
                            <SwiperSlide className='border-1 border-white border p-5 bg-primary'>  
                            <div className='row customer-items mb-3'>
                                { customer?.contacts.map( (contact,index) => {

                                    return (
                                        <div className='col-lg-4' key={ index }>
                                            <div className='bg-secondary p-3 text-start customer-item h-100'>
                                                <strong>{ [contact.first_name,contact.last_name].join(' ') }</strong><br />
                                                { contact.position}<br></br>
                                                { contact.phone && 
                                                <div><strong><i className='fa fa-phone-alt me-2'></i></strong> : { contact.phone }</div> }
                                                { contact.email && 
                                                <div><strong><i className='fa fa-envelope me-2'></i></strong> : { contact.email }</div> }
                                                <div className='btn-group'>
                                                    { customer.prospect && <button  type="button" className='btn btn-primary me-1' onClick={ () => handleDeleteContact(contact) }><i className='fa fa-trash'></i></button> }
                                                    <button  type="button" className='btn btn-primary' onClick={ () => handleEditContact(contact) }><i className='fa fa-edit'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                </div>
                                <button type='button' onClick={ () => handleEditContact(null) } className='btn btn-secondary btn-lg'>
                                    <i className='fa fa-plus me-3'></i>{ strings.contact_add }
                                </button>
                            </SwiperSlide>
                            <SwiperSlide className='border-1 border-white border p-5 bg-primary pb-2'>
                                {
                                    canShowCategoryPermission ?
                                    <div className='row category-items mb-3 p-3' style={{ maxHeight: '380px', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #fff', borderRadius: '5px' }}>
                                        { categoriesOptions.map( (category, index) => {
                                            return (
                                                <div className='form-check text-start' style={{ 'marginLeft': (category.level * 40) + 'px' }} key={ index }>
                                                    <input 
                                                        type="checkbox" 
                                                        className="form-check-input" 
                                                        id={'ec-' + category.value} 
                                                        checked={
                                                            excludedCategories.findIndex((c) => String(c.ref) === String(category.value)) === -1
                                                        }
                                                        onChange={e => handleCategoryPermission(e.target.checked, category.value)}
                                                        />
                                                    <label className='form-check-label' htmlFor={'ec-' + category.value}>
                                                        { category.label }
                                                    </label>
                                                </div>
                                            )
                                        })}
                                    </div> : ''
                                }
                                {
                                    canShowCategoryPermission ?
                                    <button type='button' disabled={ !categoryChanges } onClick={ () => saveCategoryPermission() } className='btn btn-secondary btn-lg'>
                                        <i className='fa fa-save me-3'></i>{ strings.enregistrer }
                                    </button> : ''
                                }
                            </SwiperSlide>
                            <SwiperSlide className='border-1 border-white border p-5 bg-primary pb-2'>
                                <div className='row category-items mb-3'>
                                    <DataTable
                                        columns={columns}
                                        data={customerOrders}
                                        highlightOnHover
                                        pointerOnHover
                                        pagination
                                        paginationComponentOptions={paginationComponentOptions}
                                        onRowClicked={ (row, event) => { editOrder(row.ref) } }
                                        paginationPerPage={ 10 }
                                        striped={ true }
                                        theme="bs5"
                                        customStyles={ bs5Styles }
                                        noDataComponent={ <div className='alert alert-warning w-100 m-0'><i className="fa fa-exclamation-triangle me-3"></i>{ strings.orders_noresult }</div> }
                                    />
                                </div>
                            </SwiperSlide>
                            </Swiper>
                        </div>   
                    </div>
                </form>
                <BottomNavigation className="justify-content-around">
                    <button type="button" onClick={ () => {props.updateTitle(strings.customer_details); swiperRef.current?.swiper.slideTo(0)} } className={ (swiperRef.current?.swiper.activeIndex == 0 ? "active " : "" ) + "btn btn-lg col-auto" }><i className='fs-1 fa fa-edit me-3'></i> { strings.informations }</button>
                    <button type="button" disabled={ ! customer?.ref } onClick={ () => {props.updateTitle(strings.addresses_list); swiperRef.current?.swiper.slideTo(1)} } className={ (swiperRef.current?.swiper.activeIndex == 1 ? "active " : "" ) + "btn btn-lg col-auto" }><i className='fs-1 fa fa-map me-3'></i> { strings.addresses}</button>
                    <button type="button" disabled={ ! customer?.ref } onClick={ () => {props.updateTitle(strings.contacts_list); swiperRef.current?.swiper.slideTo(2)} } className={ (swiperRef.current?.swiper.activeIndex == 2 ? "active " : "" ) + "btn btn-lg col-auto" }><i className='fs-1 fa fa-users me-3'></i> { strings.contacts }</button>
                    { canShowCategoryPermission ?
                        <button type="button" disabled={ ! customer?.ref } onClick={ () => {props.updateTitle(strings.permissions_list); swiperRef.current?.swiper.slideTo(3)} } className={ (swiperRef.current?.swiper.activeIndex == 3 ? "active " : "" ) + "btn btn-lg col-auto" }><i className='fs-1 fa fa-check-square me-3'></i> { strings.permissions }</button>
                        : ''
                    }
                    <button type="button" disabled={ ! customer?.ref } onClick={ () => {props.updateTitle(strings.orders_list); swiperRef.current?.swiper.slideTo(4)} } className={ (swiperRef.current?.swiper.activeIndex == 4 ? "active " : "" ) + "btn btn-lg col-auto" }><i className='fs-1 fa fa-clipboard-check me-3'></i> { strings.orders }</button>
                    <button type="button" disabled={ ! customer?.prospect || (! dirty && ! formChanges) } onClick={ event => { submit(event) }} className={ (swiperRef.current?.swiper.activeIndex == 5 ? "active " : "" ) + "btn btn-lg col-auto" + (saved && !dirty && !formChanges ? '' : '') }>{ saved && !dirty && !formChanges ? <><i className='fs-1 fa fa-check me-3'></i> { strings.saved }</> : <><i className='fs-1 fa fa-save me-3'></i> { strings.enregistrer }</> }</button>
                </BottomNavigation>
                </>
            )}}
            />            
            <Offcanvas placement="bottom" className="h-auto" show={ showFormAddress } onHide={handleCloseFormAddress}>
                <Offcanvas.Header closeButton className="border-bottom pb-3 bg-primary text-white"> 
                <Offcanvas.Title className="text-center flex-grow-1">{ editAddress ? strings.address_edit : strings.address_new }</Offcanvas.Title>
                </Offcanvas.Header>        
                <Offcanvas.Body>
                    <Form 
                        initialValues={editAddress}
                        onSubmit={handleSubmitAddress}
                        validate={validateAddress}
                        render={({ handleSubmit, form, submitting, pristine, values, submitSucceeded, modifiedSinceLastSubmit }) => (
                            <form onSubmit={handleSubmit} className="address-form">
                                <div className='container-fluid'>
                            
                                    <div className='row align-items-center justify-content-center'>
                                        <Field name="address1" maxLength={35} label={ strings.customer_address} classes={ {...fieldClass, input:'col-3' } }  component={ RenderInput } />
                                        <Field name="address2" maxLength={35} label={ strings.customer_address_2 } classes={ {...fieldClass, input:'col-3' } } component={ RenderInput } />
                                        <Field name="address3" maxLength={35} label={ strings.customer_address_3 } classes={ {...fieldClass, input:'col-3' } } component={ RenderInput } />
                                        <Field name="postal_code" maxLength={35} label={ strings.customer_postal_code } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="city" maxLength={35} label={ strings.customer_city } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="country" maxLength={35} label={ strings.customer_country } classes={ fieldClass } component={ RenderCountryField }  />
                                        <Field name="phone" maxLength={21} label={ strings.customer_phone } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="mobile" maxLength={21} label={ strings.customer_mobile } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="email" maxLength={69} label={ strings.email} classes={ fieldClass } component={ RenderInput } />
                                    </div>
                                    <div className='row justify-content-center mt-3'>
                                        <button type="submit" className='btn btn-submit btn-secondary col-auto btn-lg'>{ editAddress ? <><i className='fa fa-pencil-alt me-3'></i>{ strings.address_edit }</> : <><i className='fa fa-plus me-3'></i>{ strings.address_add }</> }</button>
                                    </div>
                                </div>
                            </form>
                        )} />
                </Offcanvas.Body>    
            </Offcanvas>
        
            <Offcanvas placement="bottom"  className="h-auto" show={ showFormContact } onHide={handleCloseFormContact}>
                <Offcanvas.Header closeButton className="border-bottom pb-3 bg-primary text-white">
                <Offcanvas.Title className="text-center flex-grow-1">{ editContact ? strings.contact_edit : strings.contact_add }</Offcanvas.Title>
                </Offcanvas.Header>        
                <Offcanvas.Body>
                    <Form 
                        initialValues={editContact}
                        onSubmit={handleSubmitContact}
                        validate={validateContact}
                        render={({ handleSubmit, form, submitting, pristine, values, submitSucceeded, modifiedSinceLastSubmit }) => (
                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className='container-fluid'>
                                    <div className='row align-items-center justify-content-center'>
                                        <Field name="first_name" maxLength={35} label={ strings.first_name } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="last_name" maxLength={35} label={ strings.last_name } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="position" maxLength={35} label={ strings.position } classes={ fieldClass } component={ RenderInput } />
                                    </div>
                                    <div className='row align-items-center justify-content-center'>                         
                                        <Field name="phone" maxLength={21} label={ strings.customer_phone } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="mobile" maxLength={21} label={ strings.customer_mobile } classes={ fieldClass } component={ RenderInput } />
                                        <Field name="email" maxLength={69} label={ strings.email } classes={ fieldClass } component={ RenderInput } />
                                    </div>
                                    <div className='row justify-content-center mt-3'>
                                        <button type="submit" className='btn btn-submit btn-secondary col-auto btn-lg'>{ editContact ? <><i className='fa fa-pencil-alt me-3'></i>{ strings.contact_edit }}</> : <><i className='fa fa-plus me-3'></i>{ strings.contact_new }</> }</button>
                                    </div>
                                </div>
                            </form>
                        )} />
                </Offcanvas.Body>    
            </Offcanvas>
        </>
    )
}

export default CustomerForm;